import { create, show, useModal } from "@ebay/nice-modal-react";

import ConfirmationModal from "ds/components/ConfirmationModal";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";

type BlockNavigationModalProps = {
  onConfirm: () => void;
  onCancel?: () => void;
  title?: string;
  description?: string;
  confirmationButtonLabel?: string;
};

const BlockNavigationModal = create(function BlockNavigationModal({
  onConfirm,
  onCancel,
  title = "Are you sure you want to leave?",
  description = "You have unsubmitted changes.",
  confirmationButtonLabel = "Leave",
}: BlockNavigationModalProps) {
  const modal = useModal();

  const handleOnConfirm = () => {
    modal.resolve();
    modal.hide();
    onConfirm();
  };

  return (
    <ConfirmationModal
      title={title}
      confirmationButtonLabel={confirmationButtonLabel}
      confirmationButtonVariant="dangerPrimary"
      onConfirm={handleOnConfirm}
      onClose={onCancel}
    >
      <ConfirmationModalMessage>{description}</ConfirmationModalMessage>
    </ConfirmationModal>
  );
});

export const showBlockNavigationModal = (props: BlockNavigationModalProps) =>
  show(BlockNavigationModal, props);
